import clsx from 'clsx';
import React, { useRef, useState } from 'react';
import { useComposedRefs, useElementSize, useResponsiveProp, } from '../../utils';
import { Box } from '../Box';
import { Pill } from '../Pill';
export function TagStack(props) {
    const { children, truncate = { base: 4, small: 1 }, variant = 'stacked', ...rest } = props;
    const responsiveTruncate = useResponsiveProp(truncate);
    const childCount = React.Children.count(children);
    return (React.createElement(Box.Restricted, { ...rest, className: clsx('mollie-ui-tag-stack', {
            [`mollie-ui-tag-stack--${variant}`]: variant,
        }) },
        React.Children.toArray(children)
            .slice(0, responsiveTruncate)
            .map((child) => React.isValidElement(child) ? (React.createElement(StackComponent, { key: child.key, component: child })) : (child)),
        childCount > responsiveTruncate && (React.createElement(Pill, { variant: "neutral", size: "small", className: "mollie-ui-tag-stack-element" }, `+${childCount - responsiveTruncate}`))));
}
TagStack.displayName = 'Tag.Stack';
function StackComponent(props) {
    const { component } = props;
    const elementRef = useRef(null);
    const [width, setWidth] = useState(0);
    useElementSize(elementRef, (size, element) => {
        const inlineSize = 'inlineSize' in size ? size.inlineSize : size.width;
        setWidth(inlineSize);
        // Set property early so we skip the initial transition
        element.style.setProperty('--mollie-ui-tag-stack-element-size', `${inlineSize}px`);
        /**
         * As we are using negative margins to stack elements on top of each other,
         * when the negative margin is larger than the width of the element itself,
         * this will cause the element to change its own width.
         *
         * This would end up triggering this callback again, causing an infinite loop.
         * Setting this minWidth will prevent the width of the element to get
         * smaller than it should be.
         */
        element.style.minWidth = 'min-content';
    }, 'borderBoxSize');
    return React.cloneElement(component, {
        ref: useComposedRefs(component.ref, elementRef),
        style: {
            ...component.props.style,
            '--mollie-ui-tag-stack-element-size': `${width}px`,
        },
        className: clsx('mollie-ui-tag-stack-element', component.props.className),
    });
}
//# sourceMappingURL=TagStack.js.map